import { Text, VStack } from '@bpba/ui-components';
import { Establecimiento } from '../../rest/models/Establecimiento';
import { ReactNode } from 'react';

type InformacionAdicionalProps = {
  informacionAdicional: Establecimiento | undefined;
  showTitle?: boolean;
};

const Row = ({ children }: { children: ReactNode }) => (
  <Text my="2px" color="primary.1">
    {children}
  </Text>
);

const InformacionAdicional = ({ informacionAdicional, showTitle = true }: InformacionAdicionalProps) => {
  return (
    <>
      <VStack>
        <Row>
          {informacionAdicional?.contacto && (<><b>Contacto:</b> {informacionAdicional.contacto}</>)}
        </Row>
        <Row>
          {informacionAdicional?.celular && (<><b>Celular:</b> {informacionAdicional.celular}</>)}
        </Row>
        <Row>
          {informacionAdicional?.email && (<><b>Email:</b> {informacionAdicional.email}</>)}
        </Row>
        <Row>
          {informacionAdicional?.paginaWeb && (<><b>Página web:</b> {informacionAdicional.paginaWeb}</>)}
        </Row>
        <Row>
          {informacionAdicional?.detalleRubro && (<><b>Rubro:</b> {informacionAdicional.detalleRubro}</>)}
        </Row>
      </VStack>
    </>
  );
};
export default InformacionAdicional;
